import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_10 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_11 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "User ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Bank Account"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Amount (total)"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Count")
  ])
], -1)
const _hoisted_13 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "px-4 py-6 text-center text-sm text-gray-400"
}, "No data", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "px-4 py-3 whitespace-nowrap text-sm" }
const _hoisted_18 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_19 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_20 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-700 text-right" }
const _hoisted_21 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-end" }

import { ref, watch } from 'vue';
import { inject } from 'vue';
import { useStore } from 'vuex';
import { AxiosInstance } from 'axios';
import dayjs from 'dayjs';
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue';

interface DetailRow {
  userId: string;
  bankAccount: string | null;
  totalAmount: string;
  count: string;
}

interface Props {
  show: boolean;
  adminId: string;
  adminUsername: string;
  approvedType: 'deposit' | 'withdraw';
  startDate: string;
  endDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalReportDetailDialog',
  props: {
    show: { type: Boolean },
    adminId: null,
    adminUsername: null,
    approvedType: null,
    startDate: null,
    endDate: null
  },
  emits: ["update:show"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:show', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  adminId: string;
  adminUsername: string;
  approvedType: 'deposit' | 'withdraw';
  startDate: string;
  endDate: string;
}




const axios = inject('$axios') as AxiosInstance;
const store = useStore();

const isLoading = ref(false);
const rows = ref<DetailRow[]>([]);

const formatAmount = (amount: string | number): string => {
  return (Number(amount) / 100).toLocaleString('en', {
    useGrouping: true,
    minimumFractionDigits: 2,
  });
};

const fetchDetail = async () => {
  if (!props.adminId) return;
  isLoading.value = true;
  rows.value = [];
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/transaction-admin-audit/report/detail`,
      {
        operatorId: store.state.selectedOperator.operatorId,
        adminId: props.adminId,
        approvedType: props.approvedType,
        startDate: dayjs(props.startDate).startOf('day').toISOString(),
        endDate: dayjs(props.endDate).endOf('day').toISOString(),
      },
    );
    rows.value = data;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

watch(() => props.show, (val) => {
  if (val) fetchDetail();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:show', false))),
        open: __props.show
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg font-semibold text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.adminUsername) + " — " + _toDisplayString(__props.approvedType === 'deposit' ? 'Deposit' : 'Withdraw') + " Approvals ", 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:show', false))),
                        class: "text-gray-400 hover:text-gray-600"
                      }, _hoisted_8)
                    ]),
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_font_awesome_icon, {
                            class: "text-gray-400",
                            icon: ['fas', 'circle-notch'],
                            spin: ""
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("table", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("tbody", _hoisted_13, [
                              (rows.value.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: row.userId,
                                  class: "hover:bg-gray-50"
                                }, [
                                  _createElementVNode("td", _hoisted_17, [
                                    _createVNode(_component_router_link, {
                                      to: `/players/${row.userId}`,
                                      class: "text-blue-500 hover:text-blue-700 hover:underline"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.userId), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _createElementVNode("td", _hoisted_18, _toDisplayString(row.bankAccount || '-'), 1),
                                  _createElementVNode("td", _hoisted_19, _toDisplayString(formatAmount(row.totalAmount)), 1),
                                  _createElementVNode("td", _hoisted_20, _toDisplayString(Number(row.count).toLocaleString('en')), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:show', false))),
                      class: "inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    }, " Close ")
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})